import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		verbose: false,
	},
	actions: {
		saveCurrentFullPath: function (context, fullPath): void {
			localStorage.currentFullPath = fullPath
		},
	},
})
